export const MAX_TICKETS_PER_ORDER = 25;
